module.exports = __webpack_public_path__ + "img/thank9.d902f6b0.gif";